module.exports = __webpack_public_path__ + "media/src/images/google-logo-8f89cd3112fffacea919ba2a71e7209c.png";